const faqs = [
  {
    question: 'What renewable energy solutions are available in Australia?',
    answer: 'Australia has access to multiple renewable energy solutions including solar power, wind energy, battery storage systems, and emerging hydrogen technologies. AK Energy helps you discover, compare and connect with trusted renewable energy providers across all of these categories through one unified marketplace platform.',
  },
  {
    question: 'How do I find trusted renewable energy providers in Australia?',
    answer: 'AK Energy simplifies the process by creating a trusted marketplace where verified renewable energy providers are listed. You can compare solar installers, wind energy providers, battery suppliers, and hydrogen solution companies all in one place. Every provider on the platform is verified to ensure quality and reliability for Australian customers.',
  },
  {
    question: 'Is renewable energy suitable for Australian businesses?',
    answer: 'Yes. Australian businesses of all sizes can benefit from renewable energy solutions through reduced energy costs, improved sustainability credentials, and long-term energy independence. AK Energy connects commercial and industrial customers with providers offering tailored renewable energy solutions including commercial solar installations, wind power systems, battery storage, and energy management consulting.',
  },
  {
    question: 'What is the AK Energy marketplace and how does it work?',
    answer: 'AK Energy is Australia\'s trusted renewable energy marketplace connecting households, businesses, manufacturers, installers, finance providers, and energy retailers. Simply browse our platform to discover energy solutions, compare verified providers, request quotes, and connect with the right partner for your renewable energy journey — all from one intelligent platform.',
  },
  {
    question: 'How much can I save with solar energy in Australia?',
    answer: 'Savings vary based on your location, system size, energy consumption, and feed-in tariff rates. Many Australian households see reductions of 30% or more on electricity bills after installing solar. Use our free Solar Calculator to get a personalised estimate based on your specific situation, or connect with verified providers through AK Energy for tailored quotes.',
  },
  {
    question: 'What is green hydrogen and why is it important for Australia?',
    answer: 'Green hydrogen is produced using renewable energy to split water into hydrogen and oxygen, creating a zero-emission fuel. Australia is uniquely positioned to become a global leader in hydrogen production thanks to abundant solar and wind resources. Hydrogen can power heavy industry, transport, and energy export, making it a crucial part of Australia\'s clean energy future.',
  },
];

export default function FAQSection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">FAQ</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            Everything you need to know about renewable energy solutions and how AK Energy helps Australians make smarter energy decisions.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <summary className="flex items-center justify-between gap-4 px-6 py-5 cursor-pointer list-none select-none">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-6 leading-snug">
                  {faq.question}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 shrink-0 transition-transform duration-300 group-open:rotate-45">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      {/* FAQPage Schema.org structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}